import { memo } from 'react';
import { Box } from '@mui/material';

export const StatusBlinker = memo(function StatusBlinker({
  active = false,
}: {
  active?: boolean;
}) {
  return (
    <Box
      sx={{
        width: 10,
        height: 10,
        borderRadius: '50%',
        backgroundColor: active ? 'green' : 'red',
        border: '2px solid #fff',
        boxShadow: '0 0 2px rgba(0,0,0,0.3)',
        animation: `${active ? 'colorBlinkGreen' : 'colorBlinkRed'} 1s infinite`,
        '@keyframes colorBlinkGreen': {
          '0%, 100%': { backgroundColor: 'green' },
          '50%': { backgroundColor: '#90ee90' },
        },
        '@keyframes colorBlinkRed': {
          '0%, 100%': { backgroundColor: 'red' },
          '50%': { backgroundColor: '#ff7f7f' },
        },
      }}
    />
  );
});
